// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_iX","advertCardFooter__row":"c-a_iY","advertCardFooter__name":"c-a_iZ","advertCardFooter__price":"c-a_ja","advertCardFooter__age":"c-a_jb"};